import {useMemo} from 'react';
import type {CodeListId} from 'schemaDefinition/types';
import {useLocalization} from 'localization';
import {isLinkedRoleCodeListId} from 'schemaDefinition';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';
import {useAppSelector} from 'store/hooks';
import {getLinkedRoleCodelist} from 'schemas/links/functions';
import type {CodeListMap} from '../types';
import {selectCodelists} from '../codelistsSlice';

export function useCodelistsLazy(
  codelistIds: (CodeListId | LinkedRoleCodeListId)[],
): CodeListMap | undefined {
  const localization = useLocalization();

  const codelists = useAppSelector(selectCodelists);
  return useMemo(() => {
    let anyMissing = false;
    const map = codelistIds.reduce<CodeListMap>((acc, id) => {
      if (isLinkedRoleCodeListId(id)) {
        const codelist = getLinkedRoleCodelist(id, localization);
        acc[id] = codelist;
        return acc;
      }

      const codelist = codelists[id]?.data;
      if (!codelist) {
        anyMissing = true;
        return acc;
      }

      acc[id] = codelist;
      return acc;
    }, {});
    return anyMissing ? undefined : map;
  }, [codelistIds, codelists, localization]);
}
